import * as Const from '../constants';

import FinishedForm from '../interfaces/FinishedForm';

export default function pickFormParameters (
  email, dateFrom, dateTo, fieldsArea, planePrice, typePayment, package_, product, subscriptionPeriod, createPayment
): FinishedForm {
  if (fieldsArea) {
    return {
      'user_email': email,
      'datetime_finish': dateTo || null,
      'subscription_type': typePayment,
      'product_name': product,
      'product_package_name': package_,
      'currency': Const.USD,
      'paid': +planePrice,
      'area': +fieldsArea,
      'interval_type': subscriptionPeriod,
      'create_payment': createPayment,
    };
  }
  return {
    'user_email': email,
    'datetime_finish': dateTo || null,
    'subscription_type': typePayment,
    'product_name': product,
    'product_package_name': package_,
    'currency': Const.USD,
    'paid': +planePrice,
    'interval_type': subscriptionPeriod,
    'create_payment': createPayment,
  };
}
